// extracted by mini-css-extract-plugin
module.exports = {"wr":"styles_wr__2PXDm","row":"styles_row__2DPyL","process":"styles_process__23wV-"};